import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import axios from 'axios'
import config, {prefix} from '../../config'
import {GET_NEARBY_CITY} from './actionTypes'
// import fetchData, {fetchContent} from '../../utils/fetch-data'
import {useCurrentPageAPI} from '../getCurrentPage'
// import {useCoordsAPI} from '../getCoords'

const devEnv = process.env.NODE_ENV === 'development'

const cityAliasName = () => {
  if (devEnv) {
    return config.group
  }
  return window.theme.cityAlias
}

const useActions = () => {
  const {currentPage} = useCurrentPageAPI()
  const homePage = currentPage === 'homePage'
  const cityPage = currentPage === 'cityPage' // const cityAlias = !homePage ? window.theme.cityAlias : false
  const isGroupPage = currentPage === 'groupPage'

  const dispatch = useDispatch()
  const getCity = useCallback(
    coords => {
      const {latitude, longitude} = coords
      const nearByCitiesUrl = `${prefix}/event/ajax-nearby-cities?userLat=${latitude}&userLong=${longitude}&json=1`
      dispatch({
        type: GET_NEARBY_CITY,
        payload: axios.get(nearByCitiesUrl),
      })
    },
    [dispatch, homePage]
  )

  const getGroupList = useCallback(() => {
    dispatch({
      type: GET_NEARBY_CITY,
      payload: axios.get(`${prefix}/${cityAliasName()}/city-list?sc=1`),
    })
  }, [dispatch])
  return {getGroupList, getCity}
}

export default useActions
